import React, { useEffect, useState } from 'react';
import { Layout, Tabs } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { fetchEmployees } from '../redux/slices/employeeSlice';
import { fetchLeaves } from '../redux/slices/leaveSlice';
import StatsCards from '../components/StatsCards';
import LeaveTable from '../components/LeaveTable';
import AttendanceMarker from '../components/AttendanceMarker';
import './Dashboard.css';

function Dashboard() {
  const dispatch = useDispatch();
  const [stats, setStats] = useState({});
  const { employees } = useSelector(state => state.employees);
  const { leaves } = useSelector(state => state.leaves);

  useEffect(() => {
    dispatch(fetchEmployees({ page: 1, limit: 1 }));
    dispatch(fetchLeaves({ page: 1, limit: 100 }));
  }, [dispatch]);

  useEffect(() => {
    const pendingLeaves = leaves.filter(l => l.status === 'Pending').length;
    setStats({
      totalEmployees: 245,
      pendingLeaves: pendingLeaves,
      presentToday: 218,
      monthlyPayroll: 1250000
    });
  }, [leaves]);

  const items = [
    {
      key: '1',
      label: 'Overview',
      children: <StatsCards stats={stats} />
    },
    {
      key: '2',
      label: 'Attendance',
      children: <AttendanceMarker />
    },
    {
      key: '3',
      label: 'Recent Leaves',
      children: <LeaveTable />
    }
  ];

  return (
    <Layout style={{ padding: '20px' }}>
      <h1>HRMS Dashboard</h1>
      <Tabs items={items} />
    </Layout>
  );
}

export default Dashboard;
